import styled, { css } from 'styled-components'

import {
  Skeleton as Skeleton_,
  type SkeletonProps as SkeletonProps_,
} from '@blade/ui-kit'

interface SkeletonProps extends SkeletonProps_ {}

export function Skeleton(props: SkeletonProps) {
  return <Root {...props} />
}

const Root = styled(Skeleton_)`
  background: var(--backgroundA-1);
`

interface SkeletonLineProps {
  static?: boolean
  width?: number | string | undefined
  uppercase?: boolean
  className?: string
}

Skeleton.Line = (props: SkeletonLineProps) => {
  return (
    <SkeletonLine
      static={props.static}
      width={props.width ?? '100%'}
      $uppercase={props.uppercase === true}
      height="1em"
      className={props.className}
      css={css`
        ${props.uppercase === true ? '' : 'transform: scale(1, 0.8);'}
      `}
    />
  )
}

const SkeletonLine = styled(Skeleton_)<{ $uppercase: boolean }>`
  display: inline-block;
  transform-origin: bottom;
  background: var(--backgroundA-1);
`

interface SkeletonSurfaceProps {
  static?: boolean
  className?: string
}
const SurfaceStyles = css`
  display: block;
  position: absolute;
  background: var(--backgroundA-1);
`
Skeleton.Surface = (props: SkeletonSurfaceProps) => (
  <Skeleton_
    static={props.static}
    width={'100%'}
    height={'100%'}
    className={props.className}
    css={SurfaceStyles}
  />
)

const between = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min
}
Skeleton.between = between
